<!-- IMPORTANT! - For concistency please use the following structure for future development -->
<!-- <div class="user-settings-tab-panel-wrapper">
    <div class="user-settings-control-row" fxLayout="row">
        <div class="row-content" fxflex="80%" fxlayout="column">
            <span [ngClass]="{'disabled': className}" class="user-settings-control-row_title">Setting Title</span>
            <p class="user-settings-control-row_description">Setting Description</p>
        </div>
        <div class="setting_toggle" fxflex="20%" fxlayout="row" fxlayoutalign="center">
            <bfx-toggle></bfx-toggle>
        </div>
    </div>
</div> -->

<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Panic Controls" styleClass="user-settings-tab-panel">
    <div class="userSettings-loading-message" *ngIf="!ready" fxFlexFill>Loading...</div>
    <div
      *ngIf="ready"
      [nativeDesktopStyle]="{ 'height' : '80px' }"
      class="user-settings-component-container"
    >
      <div class="user-settings-component-container" fxLayout="column">
        <div class="user-settings-control-row" fxLayout="row" fxFill>
          <div class="row-content" fxFlex="80%" fxLayout="column">
            <span class="user-settings-control-row_title">Disable Auto Fill</span>
            <p class="user-settings-control-row_description">
              Prevents orders from auto filling while active. Migrates orders in Internal and
              External Arbitration Auto Fill groups to manual.
            </p>
          </div>
          <div class="setting_toggle" fxFlex="20%">
            <bfx-toggle
              fxFlexAlign="center"
              [checked]="panicControl.orderAutoFillToggle"
              (change)="orderAutoFillToggleChanged($event)"
            >
            </bfx-toggle>
          </div>
        </div>
        <div class="user-settings-control-row" fxLayout="row" fxFill>
          <div class="row-content" fxFlex="80%" fxLayout="column">
            <span class="user-settings-control-row_title">Disable Order Book Changes</span>
            <p class="user-settings-control-row_description">
              Prevents Sales, Client and Admin users from entering, modifying or cancelling orders
              while active.
            </p>
          </div>
          <div class="setting_toggle" fxFlex="20%">
            <bfx-toggle
              fxFlexAlign="center"
              [checked]="panicControl.orderBookChangesToggle"
              (change)="orderBookChangesToggleChanged($event)"
            >
            </bfx-toggle>
          </div>
        </div>
        <div class="user-settings-control-row" fxLayout="row" fxFill>
          <div class="row-content" fxFlex="80%" fxLayout="column">
            <span class="user-settings-control-row_title">Disable Order Monitoring</span>
            <p class="user-settings-control-row_description">
              Orders will not Trigger while Order Monitoring is disabled.
            </p>
          </div>
          <div class="setting_toggle" fxFlex="20%">
            <bfx-toggle
              fxFlexAlign="center"
              [checked]="panicControl.orderMonitoringToggle"
              (change)="orderMonitoringToggleChanged($event)"
            >
            </bfx-toggle>
          </div>
        </div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
